import { postWithTokenNoErrorLog as postWithToken } from 'api/network'; // Use no log version to prevent recursive logging in case the log request encounters error

export const sendClientLog = (level, message, callback) => {
    if (level === 'Info') {
        postWithToken(`/api/logs/info`, message)
            .then(res => {
                callback && callback();
            })
            .catch(error => {
                console.log(error);     // Todo: Add error handling
            });
    }
    else if (level === 'Warn') {
        postWithToken(`/api/logs/warn`, message)
            .then(res => {
                callback && callback();
            })
            .catch(error => {
                console.log(error);     // Todo: Add error handling
            });
    }
    else {
        postWithToken(`/api/logs/error`, message)
            .then(res => {
                callback && callback();
            })
            .catch(error => {
                console.log(error);     // Todo: Add error handling
            });
    }
}